
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import SupervisorAccount from '@mui/icons-material/SupervisorAccount';
import GroupIcon from '@mui/icons-material/Group';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import SettingsIcon from '@mui/icons-material/Settings';
import PublicIcon from '@mui/icons-material/Public';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import SourceIcon from '@mui/icons-material/Source';
import TimelineIcon from '@mui/icons-material/Timeline';
import StorefrontIcon from '@mui/icons-material/Storefront';
import RouterIcon from '@mui/icons-material/Router';
import RuleIcon from '@mui/icons-material/Rule';
import LanIcon from '@mui/icons-material/Lan';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import GavelIcon from '@mui/icons-material/Gavel';
import HttpIcon from '@mui/icons-material/Http';
import TuneIcon from '@mui/icons-material/Tune';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import TelegramIcon from '@mui/icons-material/Telegram';
import ForumIcon from '@mui/icons-material/Forum';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import HandshakeIcon from '@mui/icons-material/Handshake';
import PercentIcon from '@mui/icons-material/Percent';
import WalletIcon from '@mui/icons-material/Wallet';
import EventNoteIcon from '@mui/icons-material/EventNote';
import CodeIcon from '@mui/icons-material/Code';
import VpnLockIcon from '@mui/icons-material/VpnLock';
import DnsIcon from '@mui/icons-material/Dns';

export const menuConfig = [
    {
        title: 'menu.dashboard',
        path: '/app/dashboard',
        icon: <QueryStatsIcon />
    },
    {
        title: 'pages.account.title',
        path: '/app/users',
        icon: <AccountBoxIcon />,
        sublistData: [
            {
                title: 'pages.users.title',
                icon: <SupervisorAccount />,
                controller: 'users',
                path: '/app/users'
            },
            {
                title: 'pages.roles.title',
                icon: <GroupIcon />,
                controller: 'roles',
                path: '/app/roles'
            },
            {
                title: 'pages.rolePermissions.title',
                icon: <WorkspacesIcon />,
                controller: 'role-permissions',
                path: '/app/role-permissions'
            },
            {
                title: 'pages.rolesActionsPermissions.title',
                icon: <DisplaySettingsIcon />,
                controller: 'roles-actions-permissions',
                path: '/app/roles-actions-permissions'
            }
        ]
    },
    {
        title: 'pages.merchants.title',
        icon: <StorefrontIcon />,
        sublistData: [
            {
                title: 'pages.publicMerchants.title',
                icon: <StorefrontIcon />,
                controller: 'public-merchants',
                path: '/app/merchants'
            },
            {
                title: 'pages.publicMerchantTerminals.title',
                icon: <RouterIcon />,
                controller: 'public-merchant-terminals',
                path: '/app/merchant-terminals'
            },
            {
                title: 'pages.publicMerchantTerminalBalances.title',
                icon: <AccountBalanceIcon />,
                controller: 'public-merchant-terminal-balances',
                path: '/app/merchant-terminal-balances'
            }
        ]
    },
    {
        title: 'pages.gateways.title',
        icon: <LanIcon />,
        sublistData: [
            {
                title: 'pages.publicGateways.title',
                icon: <LanIcon />,
                controller: 'public-gateways',
                path: '/app/gateways'
            },
            {
                title: 'pages.publicGatewaySettings.title',
                icon: <TuneIcon />,
                controller: 'public-gateway-settings',
                path: '/app/gateway-settings'
            },
            {
                title: 'pages.publicGatewayApis.title',
                icon: <HttpIcon />,
                controller: 'public-gateway-apis',
                path: '/app/gateway-apis'
            },
            {
                title: 'pages.publicTgBots.title',
                icon: <SmartToyIcon />,
                controller: 'public-tg-bots',
                path: '/app/tg-bots'
            },
            {
                title: 'pages.publicTgSessions.title',
                icon: <TelegramIcon />,
                controller: 'public-tg-sessions',
                path: '/app/tg-sessions'
            },
            {
                title: 'pages.publicTgSessionMessages.title',
                icon: <ForumIcon />,
                controller: 'public-tg-session-messages',
                path: '/app/tg-session-messages'
            },
            {
                title: 'pages.publicScraperScenarios.title',
                icon: <CodeIcon />,
                controller: 'public-scraper-scenarios',
                path: '/app/scraper-scenarios'
            },
            {
                title: 'pages.publicProxyLists.title',
                icon: <VpnLockIcon />,
                controller: 'public-proxy-lists',
                path: '/app/proxy-lists'
            },
            {
                title: 'pages.publicProxies.title',
                icon: <DnsIcon />,
                controller: 'public-proxies',
                path: '/app/proxies'
            },
            {
                title: 'pages.publicGatewayRules.title',
                icon: <RuleIcon />,
                controller: 'public-gateway-rules',
                path: '/app/gateway-rules'
            },
            {
                title: 'pages.publicWalletRules.title',
                icon: <RuleIcon />,
                controller: 'public-wallet-rules',
                path: '/app/wallet-rules'
            },
            {
                title: 'pages.publicWallets.title',
                icon: <WalletIcon />,
                controller: 'public-wallets',
                path: '/app/wallets'
            }
        ]
    },
    {
        title: 'pages.payin.title',
        icon: <PaymentsIcon />,
        sublistData: [
            {
                title: 'pages.payinInstances.title',
                icon: <PaymentsIcon />,
                controller: 'payin-instances',
                path: '/app/payin-instances'
            },
            {
                title: 'pages.payinEvents.title',
                icon: <EventNoteIcon />,
                controller: 'payin-events',
                path: '/app/payin-events'
            }
        ]
    },
    {
        title: 'pages.payout.title',
        icon: <ReceiptLongIcon />,
        sublistData: [
            {
                title: 'pages.payoutInstances.title',
                icon: <ReceiptLongIcon />,
                controller: 'payout-instances',
                path: '/app/payout-instances'
            },
            {
                title: 'pages.payoutEvents.title',
                icon: <EventNoteIcon />,
                controller: 'payout-events',
                path: '/app/payout-events'
            }
        ]
    },
    {
        title: 'pages.appeals.title',
        icon: <GavelIcon />,
        sublistData: [
            {
                title: 'pages.publicAppeals.title',
                icon: <GavelIcon />,
                controller: 'public-appeals',
                path: '/app/appeals'
            },
            {
                title: 'pages.publicAppealHasComments.title',
                icon: <EventNoteIcon />,
                controller: 'public-appeal-has-comments',
                path: '/app/appeal-comments'
            },
            {
                title: 'pages.publicAppealHasDocuments.title',
                icon: <FileCopyIcon />,
                controller: 'public-appeal-has-documents',
                path: '/app/appeal-documents'
            }
        ]
    },
    {
        title: 'pages.accounting.title',
        icon: <AccountTreeIcon />,
        sublistData: [
            {
                title: 'pages.accountingSystemAccounts.title',
                icon: <AccountBalanceIcon />,
                controller: 'accounting-system-accounts',
                path: '/app/system-accounts'
            },
            {
                title: 'pages.accountingExternalTransactions.title',
                icon: <SwapHorizIcon />,
                controller: 'accounting-external-transactions',
                path: '/app/external-transactions'
            },
            {
                title: 'pages.accountingGatewayTransactions.title',
                icon: <SwapHorizIcon />,
                controller: 'accounting-gateway-transactions',
                path: '/app/gateway-transactions'
            },
            {
                title: 'pages.accountingWalletTransfers.title',
                icon: <SwapHorizIcon />,
                controller: 'accounting-wallet-transfers',
                path: '/app/wallet-transfers'
            },
            {
                title: 'pages.accountingGatewayWalletTransfers.title',
                icon: <SwapHorizIcon />,
                controller: 'accounting-gateway-wallet-transfers',
                path: '/app/gateway-wallet-transfers'
            },
            {
                title: 'pages.accountingSystemTransactions.title',
                icon: <SwapHorizIcon />,
                controller: 'accounting-system-transactions',
                path: '/app/system-transactions'
            },
            {
                title: 'pages.accountingExpensesTransactions.title',
                icon: <AttachMoneyIcon />,
                controller: 'accounting-expenses-transactions',
                path: '/app/expenses-transactions'
            },
            {
                title: 'pages.accountingRevenueTransactions.title',
                icon: <AttachMoneyIcon />,
                controller: 'accounting-revenue-transactions',
                path: '/app/revenue-transactions'
            }
        ]
    },
    {
        title: 'pages.publicCommissions.title',
        icon: <PercentIcon />,
        controller: 'public-commissions',
        path: '/app/commissions'
    },
    {
        title: 'pages.publicAgents.title',
        icon: <HandshakeIcon />,
        controller: 'public-agents',
        path: '/app/agents'
    },
    {
        title: 'pages.callbackprocessorUrlCallbacks.title',
        icon: <HttpIcon />,
        controller: 'callbackprocessor-url-callbacks',
        path: '/app/url-callbacks'
    },
    {
        title: 'pages.settings.title',
        icon: <SettingsIcon />,
        sublistData: [
            {
                title: 'pages.publicCountries.title',
                icon: <PublicIcon />,
                controller: 'public-countries',
                path: '/app/countries'
            },
            {
                title: 'pages.publicCurrencies.title',
                icon: <AttachMoneyIcon />,
                controller: 'public-currencies',
                path: '/app/currencies'
            },
            {
                title: 'pages.publicCurrencyRateSources.title',
                icon: <SourceIcon />,
                controller: 'public-currency-rate-sources',
                path: '/app/currency-rate-sources'
            },
            {
                title: 'pages.publicCurrentCurrencyRates.title',
                icon: <CurrencyExchangeIcon />,
                controller: 'public-current-currency-rates',
                path: '/app/current-currency-rates'
            },
            {
                title: 'pages.publicCurrencyRates.title',
                icon: <TimelineIcon />,
                controller: 'public-currency-rates',
                path: '/app/currency-rates'
            },
            {
                title: 'pages.publicBanks.title',
                icon: <AccountBalanceIcon />,
                controller: 'public-banks',
                path: '/app/banks'
            },
            {
                title: 'pages.exportCsvTasks.title',
                icon: <FileCopyIcon />,
                controller: 'public-export-tasks',
                path: 'export-csv-tasks'
            }
        ]
    },
];

